import { coerceBooleanProperty } from "@angular/cdk/coercion";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

import { ProgressBar } from "../progress-bar/progress-bar";
import { TopNavigationPanel } from "../top-navigation-panel";

export interface FunnelHeaderMilestone {
  title: string;
  text: string;
  steps: FunnelHeaderStep[];
}

export interface FunnelHeaderStep {
  title: string;
  path: string;
  type?: string;
}

export enum FunnelHeaderStepType {
  DIGITAL_APPLICATION = "digitalApplication",
}

@Component({
  standalone: true,
  imports: [ProgressBar, TopNavigationPanel],
  selector: "pax-funnel-header",
  styleUrls: ["./funnel-header.scss"],
  templateUrl: "./funnel-header.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunnelHeader {
  @Input()
  allMilestones: FunnelHeaderMilestone[] | undefined;

  @Input()
  headerText: string | undefined;

  @Input({ transform: coerceBooleanProperty })
  enableBackButton: boolean = false;

  @Output()
  back = new EventEmitter<void>();
}
